let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aOhXV")).then(() => parcelRequire('cEvik'));